module.exports = __webpack_public_path__ + "static/media/dol-upload.1d7cac16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adtemplates/dol-upload.jpg
// module id = 1475
// module chunks = 1